module.exports = __webpack_public_path__ + "img/homepage.a08fd7c3.png";